import { render, staticRenderFns } from "./MdButton.vue?vue&type=template&id=6a642584&"
import script from "./MdButton.vue?vue&type=script&lang=js&"
export * from "./MdButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports